import React, {useLayoutEffect, useState} from "react";
import {CardOrder} from "ts/api/order";
import OrderSummary from "view/apps/Exhibitor/pages/Cart/components/Payment/components/Card/OrdersList/OrderSummary";
import PaymentButtons, {
  PaymentButtonsProps,
} from "view/apps/Exhibitor/pages/Cart/components/Payment/components/Card/OrdersList/OrderSummary/PaymentButtons";
import Alert from "view/components/Alert";
import {StepOrder} from "view/apps/Exhibitor/pages/Cart/components/Payment/components/Card/OrdersList";
import {useCurrentShow} from "hooks";
import ProductList from "view/apps/Exhibitor/pages/Cart/components/Payment/components/Card/OrdersList/CartOrder/ProductList";
import makeStyles from "./styles";

type CartOrderProps = Omit<
  PaymentButtonsProps,
  "hasError" | "show" | "stepState" | "standId"
> & {
  order: CardOrder;
  orderStep: StepOrder;
  onSkip: () => void;
  onPay: () => Promise<void>;
};

const CartOrder = ({
  order,
  orderStep,
  onSkip,
  onPay,
  isLastToPay,
  isLastToSkip,
  isPaymentDisabled,
  isSubmitting,
}: CartOrderProps) => {
  const classes = makeStyles();
  const {error, isPaid} = orderStep;
  const [footerHeight, setFooterHeight] = useState<number>(0);
  const [footerEl, setFooterEl] = useState<HTMLDivElement | null>(null);

  const [show] = useCurrentShow();

  useLayoutEffect(() => {
    if (!footerEl) {
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      if (entry.target === footerEl) {
        const {height} = entry.contentRect;
        setFooterHeight(height);
      }
    });

    observer.observe(footerEl);
    return () => {
      observer.disconnect();
    };
  }, [footerEl]);

  if (!show || !order) {
    return null;
  }

  return (
    <div className={classes.root} style={{paddingBottom: footerHeight + 50}}>
      <ProductList order={order} />
      <div
        className={classes.footer}
        ref={(node) => {
          if (node instanceof HTMLDivElement) {
            setFooterEl(node);
          }
        }}
      >
        <OrderSummary
          order={order}
          hasError={!!error}
          isPaid={isPaid}
          show={show}
        />
        {!!error && <Alert severity="error">{error}</Alert>}
        <PaymentButtons
          onPay={onPay}
          onSkip={onSkip}
          isLastToPay={isLastToPay}
          isLastToSkip={isLastToSkip}
          stepState={orderStep}
          isPaymentDisabled={isPaymentDisabled}
          isSubmitting={isSubmitting}
          show={show}
          standId={order.standId}
        />
      </div>
    </div>
  );
};

export default CartOrder;
